import React, { useMemo } from 'react';
import OrderSelect, { OrderSelectProps } from '../../Common/Select';
import { useCompaniesGetAll } from '../../../../../../hooks/api/company';

interface SelectCompanyProps extends OrderSelectProps {
  currValue?: string;
}

function SelectCompany({
  fetch,
  selectProps = {},
  rest = {},
  currValue,
  ...props
}: SelectCompanyProps) {
  const dualUseGet = useCompaniesGetAll();

  const currentItem = useMemo(() => (
    dualUseGet.data?.find((item) => item.value === currValue)
  ), [dualUseGet.data, currValue]);

  return (
    <OrderSelect
      fetch={dualUseGet}
      selectProps={selectProps}
      rest={rest}
      rightText={currentItem ? currentItem?.displayName : undefined}
      {...props}
    />
  );
}

export default SelectCompany;
